<template>
  <thux-table
    :instance="instance"
    :instance-name="instanceName"
    :order-by-dict="orderByDict"
    :goBack="goBack"
    :list="list"
    :fieldName="fieldName"
    :fields="fields"
    :fields-column="fieldsColumn"
    :select-all="selectAll"
    :selected-list="selectedList"
    :get-local-selected-all="getLocalSelectedAll"
    :local-selected-list="localSelectedList"
    @check-all="checkAll"
    @check-none="checkNone"
    @set-selected-row="setSelectedRow"
    :show-checks="showChecks"
    :showDetailButton="showDetailButton"
    @change-status="changeInstanceStatus"
    @sort-changed="orderTable"
    @remove-order-by="removeOrderFromTable"
    @open-detail-form="$emit('open-detail-form', $event)"
  />
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as QUOTATION_EXTRA_MODULE_TYPES } from './store'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxTableMixin from '../../../components/thux-table/ThuxTableMixin'
import ThuxTableChecksMixin from '../../../components/thux-table/thux-table-checks/ThuxTableChecksMixin'

export default {
  name: 'QuotationExtraModuleTable',
  mixins: [ThuxTableMixin, ThuxTableChecksMixin],
  data () {
    return {
      fields: [
        {
          key: 'checks',
          label: this.$t('Checks')
        },
        {
          key: 'status',
          label: this.$t('Status'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'status'
        },
        {
          key: 'code',
          label: this.$t('Code'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'code'
        },
        {
          key: 'name',
          label: this.$t('Name'),
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
          sortable: true,
          value: 'name'
        },
        {
          key: 'action',
          label: this.$t('Actions'),
          tdClass: 'text-right text-nowrap',
          thClass: 'text-right text-nowrap'
        }
      ],
      fieldsColumn: ['status', 'code', 'name', 'slug']
    }
  },
  computed: {
    ...mapGetters({
      selectAll: QUOTATION_EXTRA_MODULE_TYPES.GENERIC.quotation.quotationextramodule.LIST.GETTERS.selectAll,
      selectedList: QUOTATION_EXTRA_MODULE_TYPES.GENERIC.quotation.quotationextramodule.LIST.GETTERS.selectedList
    }),
    showChecks () {
      return true
    },
    showDetailButton () {
      return hasPerm('quotation_quotationextramodule_retrieve')
    }
  },
  methods: {
    ...mapMutations({
      setList: QUOTATION_EXTRA_MODULE_TYPES.GENERIC.quotation.quotationextramodule.LIST.MUTATIONS.setList,
      setSelectedList:
        QUOTATION_EXTRA_MODULE_TYPES.GENERIC.quotation.quotationextramodule.LIST.MUTATIONS.setSelectedList,
      setSelectAll: QUOTATION_EXTRA_MODULE_TYPES.GENERIC.quotation.quotationextramodule.LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...QUOTATION_EXTRA_MODULE_TYPES.GENERIC.quotation.quotationextramodule.LIST.ACTIONS
    })
  }
}
</script>
